import * as types from '@/vuex/mutation-types'
import redirect from '@/utils/redirect'

export async function checkAuth (store, urlOnError) {
  // try to load user authorities and redirect through /authorize
  // if there are any errors. Any error is most likely a 401.
  try {
    await store.dispatch(types.AUTH_GET_USER_AUTHORITIES)
    if (!store.getters.hasAuths) {
      redirect.redirectTo(urlOnError)
    }
  } catch (err) {
    redirect.redirectTo(urlOnError)
    throw err
  }
}
